module.exports = __webpack_public_path__ + "img/media-24.a47809d4.png";